module.exports = require('./google_analytics')



/** WEBPACK FOOTER **
 ** ./src/plugins/google_analytics/index.js
 **/